import { Slider } from "@/lib/components/Slider";
import { PercentageInput } from "@/lib/components/PercentageInput";
import { useEditorStore } from "@/lib/stores/editor-store/editor-store";
import { getBackgroundMusicVolume } from "@repo/api/utils/composition";
import { IconVolume } from "@tabler/icons-react";
import { useCallback, useEffect, useState } from "react";

export default function MusicVolumeControl() {
  const volume = useEditorStore((state) =>
    Math.round(getBackgroundMusicVolume(state.video!.compositionJson) * 100),
  );

  const updateVideo = useEditorStore((state) => state.service.updateVideo);

  const [value, setValue] = useState(volume);

  useEffect(() => {
    setValue(volume);
  }, [volume]);

  const onChange = useCallback(
    (value: number) => {
      updateVideo((video) => {
        video.compositionJson.backgroundMusic!.volume = value / 100;
      });
    },
    [updateVideo],
  );

  return (
    <div className="mt-8 w-full">
      <div className="input-label">Volume</div>

      <div className="flex w-80 items-center gap-4">
        <PercentageInput
          className="w-48"
          value={value}
          max={200}
          onChange={(newValue) => {
            setValue(newValue);
            onChange(newValue);
          }}
          leadingComponent={
            <IconVolume className="text-text-secondary" stroke={2} size={17} />
          }
        />
        <Slider
          value={value}
          onValueChange={setValue}
          onValueCommit={(newValue) => {
            setValue(newValue);
            onChange(newValue);
          }}
          min={0}
          max={200}
          step={1}
        />
      </div>
    </div>
  );
}
